"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSurcharge = void 0;
var isSurcharge = function (itemSku) {
    return itemSku.includes("SURCHARGE");
};
exports.isSurcharge = isSurcharge;
